import React, { useEffect, useRef } from 'react';
import {
  MenuItem,
  MenuItemInner,
  IconContainer,
  Title,
  SubTitle,
  ContentWrapper,
} from './ListItem.styled';

import { Assignment, Provider } from './assignmentType';
import { getAssignmentSubtitle } from './utils/getAssignmentSubtitle';
import { ProviderLogo } from './ProviderLogo';

export const ListItem = ({
  assignment,
  onSelect,
  first,
  dataTestId,
}: {
  assignment: Assignment;
  onSelect: (data: Assignment) => void;
  first: boolean;
  dataTestId: string;
}) => {
  const menuItemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // A dirty hack to focus the first assignment
    // right after the list is visible and the loader
    // is removed
    if (first) {
      menuItemRef?.current?.focus();
    }
  }, [first]);

  const { provider } = assignment;
  const isManualAssignment = provider === Provider.Manual;
  const { closedAt, endDate, startDate } = assignment;
  const subtitle = isManualAssignment ? (
    <span>Manual assignment</span>
  ) : (
    getAssignmentSubtitle({ closedAt, endDate, startDate })
  );
  return (
    <MenuItem
      onClick={() => onSelect(assignment)}
      ref={menuItemRef}
      data-testid={dataTestId}
      aria-label={assignment.title}
    >
      <MenuItemInner>
        <IconContainer>
          <ProviderLogo provider={provider} />
        </IconContainer>
        <ContentWrapper>
          <Title>{assignment.title}</Title>
          <SubTitle>{subtitle}</SubTitle>
        </ContentWrapper>
      </MenuItemInner>
    </MenuItem>
  );
};
